import { MouseEvent, useState } from 'react';

import { ICON_OPTIONS_VERTICAL } from '~/components/icon';

import { StyledIcon } from './game-info.styles';
import { ButtonContainer } from './primary-section.styles';
import {
	MenuContainer,
	MenuItemContainer,
	MenuIconContainer,
	MenuTextContainer,
	MenuWrapper
} from './kebab-menu.styles';

type MenuItem = {
	icon: string;
	text: string;
	action: (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => void;
};

type Props = {
	items: MenuItem[];
	hasRegulationHeader: boolean;
};

const KebabMenu = ({ items, hasRegulationHeader }: Props) => {
	const [showMenu, setShowMenu] = useState(false);

	const toggleMenu = () => {
		setShowMenu(prevShowMenu => !prevShowMenu);
	};

	const handleItemClick = (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>, item: MenuItem) => {
		e.preventDefault();
		e.stopPropagation();
		item.action(e);
	};

	return (
		<>
			<ButtonContainer onClick={toggleMenu}>
				<StyledIcon type={ICON_OPTIONS_VERTICAL} color="var(--game-info-name-text-color)" />
			</ButtonContainer>
			{showMenu && (
				<MenuWrapper onClick={toggleMenu}>
					<MenuContainer hasRegulationHeader={hasRegulationHeader}>
						{items.map(item => (
							<MenuItemContainer key={item.text} onClick={e => handleItemClick(e, item)}>
								<MenuIconContainer>
									<StyledIcon type={item.icon} color="var(--game-info-menu-icon-color)" />
								</MenuIconContainer>
								<MenuTextContainer>{item.text}</MenuTextContainer>
							</MenuItemContainer>
						))}
					</MenuContainer>
				</MenuWrapper>
			)}
		</>
	);
};

export default KebabMenu;
